import Category from './Category';
import Tag from './Tag';
import Ratings from './Ratings';

export {
  Category as FilterCategory,
  Tag as FilterTag,
  Ratings as FilterRatings,
};
